export default __webpack_public_path__ + "static/media/kid-5.68dd6f80.JPG";